import { IngredientKind } from '@sg/graphql-schema';

import type { Modification } from '../../types';

export function checkIfBaseIngredient(modification: Modification) {
  const kind = modification.ingredient?.kind;

  return kind === IngredientKind.Base;
}
